<template lang="pug">
    el-dialog(title="比赛记录",width="95%",:visible.sync='visible' :append-to-body='true' :modal-append-to-body='false')
        el-form(:model="ruleForm",:inline="true",label-suffix=":" label-width="90px")
            el-card(shadow="never")
                el-form-item(label="俱乐部名" prop="name")
                    div.width_label {{ruleForm.name}}
                el-form-item(label="会长姓名" prop="chairman")
                    div.width_label {{ruleForm.chairman}}
                el-form-item(label="会长账号" prop="chairmanId")
                    div.width_label {{ruleForm.chairmanId}}
                br
                el-form-item(label="俱乐部等级" prop="level")
                    div.width_label {{ruleForm.level}}
                el-form-item(label="俱乐部积分")
                    div.width_label {{ruleForm.yearScore}}
                el-form-item(label="注册时间" )
                    div.width_label {{ruleForm.enrollTime}}
                el-form-item(label="全员女子")
                    div.width_label {{ruleForm.allWomen}}
                br
                el-form-item(label='比赛类型')
                    el-select.inputWidth( clearable style='width:280px;' v-model="ruleForm.matchType")
                        el-option(label="常规赛" :value="1")
                        el-option(label="月度赛" :value="2")
                        el-option(label="季度赛" :value="3")
                        el-option(label="年度总决赛" :value="4")
                        el-option(label="挑战赛" :value="5")
                        el-option(label="群英赛" :value="6")
                el-form-item(label="比赛时间" )
                    el-date-picker.inputWidth(v-model="ruleForm.playTime" style='width:300px;'  range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd")
                el-form-item(label="" style='float:right;')
                    el-button(@click='queryList()',type='primary',icon='el-icon-search',style='float:right;') 查 询
        el-row(style="padding-top:10px")
            el-col(:span="24")
                el-table(:data="gradeData" border)
                    el-table-column(prop="matchId" label="赛事ID" align="center")
                    el-table-column(prop="matchName" label="赛事名称" align="center")
                    el-table-column(prop="matchStartTime" label="比赛时间" align="center")
                    el-table-column(prop="venueAddress" label="比赛地点" align="center")
                    el-table-column(prop="ctType" label="比赛类型" align="center")
                        template(slot-scope="scope")
                            span() {{{1:'常规赛',2:'月度赛',3:'季度赛',4:'年度总决赛',5:'挑战赛',6:'群英赛'}[scope.row.ctType]}}
                    el-table-column(prop="rank" label="总名次" align="center")
                    el-table-column(prop="score" label="获得积分" align="center" :min="0")
                    el-table-column(prop="remark" label="积分奖惩说明" align="center" :show-overflow-tooltip='true')
                    el-table-column(prop='',header-align='center',align='center',label='操作' width='100')
                        template(slot-scope="scope")
                          el-menu.menuPonit(   @open="handleOpen" @close="handleClose" :collapse="isCollapse" )
                            el-submenu(index="1")
                                template(slot="title")
                                    i(class="el-icon-more" style='color:#02B90D;')
                                el-menu-item-group()
                                    el-menu-item(index="1-1" @click="queryHandle(scope.row.id)" v-if="isAuth('ct:level:info')") 查看详情
                                    el-menu-item(index="1-2" @click="addOrUpdateHandle(scope.row)" v-if="isAuth('ct:level:update')&&scope.row.status==0" ) 积分扣除
                                    el-menu-item(index="1-3" @click='memberManage(scope.row)' v-if="isAuth('ct:level:apply')&&scope.row.status==1" ) 取消扣除
        el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')

        el-dialog(title="请填写理由", :visible.sync='visible_jf' width="50%" :append-to-body='true' :modal-append-to-body='false' )
          el-input(type="textarea" :rows="5" resize="none" v-model="resons" )
          span.dialog-footer(slot="footer")
            el-button(@click="resons_save" ) 确 定
            el-button(@click="visible_jf=false") 返 回
        span.dialog-footer(slot="footer")
            el-button(@click="visible=false") 返 回
</template>
<script>
export default {
  data () {
    return {
      isCollapse: true,
      visible: false,
      ruleForm: {
        id: null,
        name: '',
        chairman: '',
        chairmanId: '',
        level: '',
        score: '',
        enrollTime: '',
        allWomen: '',
        matchType: '',
        playTime: []
      },
      gradeData: [],
      totalPage: 0,
      pageIndex: 1,
      pageSize: 10,
      loading: null,
      // 积分
      visible_jf: false,
      resons: '',
      jf_id: '',
      jfType: 0 //1扣除 0取消
    }
  },
  methods: {
    //操作三点
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },
    init (id, row) {
      console.log(row, 123)
      this.visible = true
      this.gradeData = []
      //回
      this.ruleForm.id = id || ''
      this.ruleForm.name = row.name
      this.ruleForm.chairman = row.chairman
      this.ruleForm.chairmanId = row.chairmanId
      this.ruleForm.level = { 1: '甲A', 2: '甲B', 3: '乙A', 4: '乙B', 5: '丙A', 6: '丙B', 7: '丁A', 8: '丁B', 9: '资格' }[row.level]
      this.ruleForm.yearScore = row.yearScore
      this.ruleForm.enrollTime = row.enrollTime
      this.ruleForm.allWomen = { 1: '是', 2: '否' }[row.allWomen]
      this.ruleForm.matchType = ''
      this.ruleForm.playTime = []
      this.queryList()
    },
    queryList () {
      this.$http({
        url: this.$http.adornUrl(`/ctScore/list`),
        method: 'post',
        data: {
          participantInfoId: this.ruleForm.id,
          ctType: this.ruleForm.matchType,
          ctStrTime: this.ruleForm.playTime[0] || '',
          ctEndTime: this.ruleForm.playTime[1] || '',
          limit: this.pageSize,
          page: this.pageIndex

        }
      }).then(res => {
        if (res && res.code == 0) {
          this.gradeData = res.page.records
          this.totalPage = res.page.total
        } else {
          this.gradeData = []
          this.totalPage = 0
        }
      })
    },
    // 分页
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.queryList()
    },
    currentChangeHandle (val) {
      this.pageIndex = val
      this.queryList()
    },

    addOrUpdateHandle (row) {
      this.resons = ''
      this.visible_jf = true
      this.jf_id = row
      this.jfType = 1
    },
    memberManage (row) {
      this.resons = ''
      this.visible_jf = true
      this.jf_id = row
      this.jfType = 0
    },
    resons_save () {
      this.jf_id.status = this.jfType
      this.jf_id.remark = this.resons
      this.jf_id.mbMemberId = this.jf_id.participantInfoId
      // console.log(this.jf_id)
      this.$http({
        url: this.$http.adornUrl(`/ctScore/update`),
        method: 'post',
        data: this.jf_id
      }).then(res => {
        if (res && res.code == 0) {
          this.$message.success('操作成功！')
          this.visible_jf = false
          this.queryList()
        } else {
          this.$message.error('操作失败！')
        }
      })
    },
    queryHandle (id) {
      // 跳转
      this.visible = false
      this.$router.push({ path: '/ct/competition/club', query: { id: id } })
    },
    openFullScreen () {
      this.loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    }
  }
}
</script>
